<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>

<script>
export default {
  computed: {
    layout() {
      let dlayout = this.$route.meta.layout==undefined ? '':this.$route.meta.layout
       console.log('layout',dlayout);
      return `${dlayout || 'default'}-layout`;
    },
  },
};
</script>
